import { useId, type JSX } from 'react';
interface CustomComboIconProps {
    className?: string;
    size?: string | number;
    /** Override the default Diamond gradient with a solid fill. */
    color?: string;
}

export const CustomComboIcon = ({ className, size, color }: CustomComboIconProps): JSX.Element => {
    const sizeStyle = typeof size === 'number' ? `${size}px` : size;
    // Per-instance gradient id — SVG defs are document-scoped, so without this
    // every CustomComboIcon on the page would resolve `url(#combo_paint)` to
    // the first SVG's gradient and subsequent icons would lose their fill once
    // that node was removed/reordered.
    const gradientId = useId();
    const fill = color ?? `url(#${gradientId})`;

    return (
        <svg
            viewBox="0 0 20 15"
            className={className}
            style={{
                width: sizeStyle || 'inherit',
                height: sizeStyle || 'inherit',
                display: 'inline-block',
                overflow: 'visible',
                verticalAlign: 'middle',
            }}
            fill="none"
        >
            <path
                d="M7.5 0C7.72222 0 7.93783 0.0419922 8.14616 0.125326C8.35422 0.208616 8.53471 0.333241 8.68734 0.499674L7.5 1.66667L2.39109 6.79418C2.00227 7.18441 2.00227 7.81559 2.39109 8.20582L7.5 13.3333L8.68734 14.5207C8.53466 14.6734 8.35433 14.7913 8.14616 14.8747C7.93783 14.958 7.72222 15 7.5 15C7.27778 15 7.06581 14.9616 6.86442 14.8853C6.66311 14.8089 6.48574 14.6873 6.33301 14.5207L0.520833 8.68734C0.36811 8.52071 0.242871 8.33691 0.145671 8.13558C0.0484483 7.93419 0 7.72222 0 7.5C0 7.27778 0.0484483 7.06581 0.145671 6.86442C0.242888 6.66306 0.368073 6.48577 0.520833 6.33301L6.33301 0.499674C6.49964 0.333042 6.6806 0.208659 6.875 0.125326C7.06944 0.0419922 7.27778 0 7.5 0Z"
                fill={fill}
            />
            <path
                d="M13.3333 5V6.66667H15V8.33333H13.3333V10H11.6667V8.33333H10V6.66667H11.6667V5H13.3333Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 0C12.7222 0 12.9378 0.0419922 13.1462 0.125326C13.3542 0.208616 13.5347 0.333241 13.6873 0.499674L19.4792 6.33301C19.6319 6.49967 19.7571 6.68056 19.8543 6.875C19.9515 7.06943 20 7.2778 20 7.5C20 7.72222 19.9552 7.93419 19.8649 8.13558C19.7746 8.33693 19.6458 8.5207 19.4792 8.68734L13.6873 14.5207C13.5347 14.6734 13.3543 14.7913 13.1462 14.8747C12.9378 14.958 12.7222 15 12.5 15C12.2778 15 12.0658 14.9616 11.8644 14.8853C11.6631 14.8089 11.4857 14.6873 11.333 14.5207L5.52083 8.68734C5.36811 8.52071 5.24287 8.33691 5.14567 8.13558C5.04845 7.93419 5 7.72222 5 7.5C5 7.27778 5.04845 7.06581 5.14567 6.86442C5.24289 6.66306 5.36807 6.48577 5.52083 6.33301L11.333 0.499674C11.4996 0.333041 11.6806 0.208659 11.875 0.125326C12.0694 0.0419922 12.2778 0 12.5 0ZM6.68783 7.5L12.5 13.3333L18.3122 7.5L12.5 1.66667L6.68783 7.5Z"
                fill={fill}
            />
            {!color && (
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="14.4" y2="19.2" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#82D9D9" />
                        <stop offset="0.1" stopColor="#8D8DD9" />
                        <stop offset="0.2" stopColor="#D998D9" />
                        <stop offset="0.4" stopColor="#D9D9B8" />
                        <stop offset="0.5" stopColor="#98D9D9" />
                        <stop offset="0.6" stopColor="#7C82BF" />
                        <stop offset="0.75" stopColor="#8D8DD9" />
                        <stop offset="0.9" stopColor="#D9D9B8" />
                        <stop offset="1" stopColor="#82D982" />
                    </linearGradient>
                </defs>
            )}
        </svg>
    );
};
